import { PublicNav, PublicFooter } from "@/components/PublicNav";
import SEO from "@/components/SEO";
import Hero from "@/components/home/Hero";
import SignatureDrinks from "@/components/home/SignatureDrinks";
import CraftedWithLove from "@/components/home/CraftedWithLove";
import BobaHistory from "@/components/home/BobaHistory";
import LocationsTeaser from "@/components/home/LocationsTeaser";
import RewardsCTA from "@/components/home/RewardsCTA";

const HOME_JSONLD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "The Boba Place",
  "url": "https://theboba.place/",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://theboba.place/menu?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

export default function Home() {
  return (
    <div data-testid="page-home" className="bp-fade-in">
      <SEO
        path="/"
        title={null}
        description="Small-batch boba and tea drinks with hand-cooked tapioca pearls and slow-steeped teas in Hailey, Ketchum and Sun Valley, Idaho. Join rewards and earn a point for every dollar."
        jsonLd={HOME_JSONLD}
      />
      <PublicNav />
      <Hero />
      <SignatureDrinks />
      <CraftedWithLove />
      <BobaHistory />
      <LocationsTeaser />
      <RewardsCTA />
      <PublicFooter />
    </div>
  );
}
